var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
import { __decorate, __metadata } from "tslib";
import { ElMessage } from 'element-plus';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
import { Pagination } from '@/core/enums/Pagination';
import { Mutations, Actions } from '@/store/enums/hrgs/master/AssessorEnum';
import TMasterAssessorList from '@/core/types/entities/hrgs/master/assessor/MasterAssessorList';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/assessors`,
    getUserInfo: `${API_URL}/api/users`,
    getSchemes: `${API_URL}/api/schemes`,
    getSites: `${API_URL}/api/sites`,
    postFile: `${API_URL}/api/upload/image?`
};
let MasterAssessorModule = class MasterAssessorModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.nikSearchLoading = false;
        this.modalFilterLoading = false;
        this.masterAssessorList = [];
        this.masterAssessorFormInput = {
            userId: null,
            regNumber: '',
            schemes: [
                {
                    attachment: '',
                    schemeId: '',
                    fileInput: []
                }
            ]
        };
        this.nikDetail = {
            id: '',
            email: '',
            fullName: '',
            gender: '',
            mobile: '',
            site: ''
        };
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1,
            loading: false
        };
        this.filters = {
            siteId: null,
            schemeId: null,
            searchName: null,
            searchMobile: null,
            searchEmail: null,
            searchUserId: null,
            searchRegNumber: null
        };
        this.orderBy = null;
        this.initMasterAssessorFormInput = JSON.parse(JSON.stringify(this.masterAssessorFormInput)); // for clearing the form input data
        this.initNikDetail = JSON.parse(JSON.stringify(this.nikDetail)); // for clearing the nik(user) detail data
        this.nikDetailOptions = [];
        this.schemesOptions = [];
        this.siteOptions = [];
    }
    // SECTION
    // *GETTERS* //
    get getMasterAssessorList() {
        return this.masterAssessorList;
    }
    get getPaginationMasterAssessorList() {
        return this.pagination;
    }
    get getIsMasterAssessorListDataLoading() {
        return this.loading;
    }
    get getIsMasterAssessorListPaginationLoading() {
        return this.pagination.loading;
    }
    get getMasterAssessorNikOptionsList() {
        return this.nikDetailOptions;
    }
    get getMasterAssessorSchemesOptionsList() {
        return this.schemesOptions;
    }
    get getMasterAssessorSiteOptionsList() {
        return this.siteOptions;
    }
    get getMasterAssessorFormInput() {
        return this.masterAssessorFormInput;
    }
    get getSelectedNikDetail() {
        return this.nikDetail;
    }
    get getSelectedNikDetailFromFirstArrayItem() {
        return this.nikDetailOptions.filter((item) => {
            return item.value == this.masterAssessorFormInput.userId;
        });
    }
    get getNikOptionsLoading() {
        return this.nikSearchLoading;
    }
    get getModalFilterLoading() {
        return this.modalFilterLoading;
    }
    get getNonNullFilter() {
        return Object.fromEntries(Object.entries(this.filters).filter(([, value]) => {
            return value !== null;
        }));
    }
    // SECTION
    // *MUTATIONS* //
    [_a = Mutations.SET_MASTER_ASSESSOR_LIST](data) {
        const newFormattedArr = data.map((element) => {
            return new TMasterAssessorList(element);
        });
        this.masterAssessorList = newFormattedArr;
    }
    [_b = Mutations.SET_LOADING](state) {
        this.loading = state;
    }
    [_c = Mutations.SET_PAGINATION_LOADING](state) {
        this.pagination.loading = state;
    }
    [_d = Mutations.SET_NIK_SEARCH_LOADING](payload) {
        this.nikSearchLoading = payload;
    }
    [_e = Mutations.SET_MODAL_LOADING](payload) {
        this.modalFilterLoading = payload;
    }
    [_f = Mutations.SET_PAGINATION_TOTAL_PAGE]() {
        this.pagination.totalPage = this.masterAssessorList.length;
    }
    [_g = Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize),
            loading: false
        };
    }
    [_h = Mutations.SET_NIK_OPTIONS](payload) {
        const formattedOptions = payload.map((element) => {
            return Object.assign({ value: element.id, label: element.id }, element);
        });
        this.nikDetailOptions = formattedOptions;
    }
    [_j = Mutations.SET_SCHEMA_OPTIONS](payload) {
        const formattedOptions = payload.map((element) => {
            return {
                value: element.id,
                label: element.title
            };
        });
        this.schemesOptions = formattedOptions;
    }
    [_k = Mutations.SET_SITE_OPTIONS](payload) {
        const formattedOptions = payload.map((element) => {
            return {
                value: element.id,
                label: element.name
            };
        });
        this.siteOptions = formattedOptions;
    }
    [_l = Mutations.CLEAR_FORM_INPUT]() {
        this.masterAssessorFormInput = JSON.parse(JSON.stringify(this.initMasterAssessorFormInput));
        this.nikDetail = Object.assign({}, this.initNikDetail);
    }
    [_m = Mutations.SET_EDIT_LIST](payload) {
        const formattedSchemes = payload.schemes.map((element) => {
            var _7, _8, _9;
            return {
                attachment: element.attachment,
                schemeId: element.id,
                fileInput: ((_7 = element.attachment) === null || _7 === void 0 ? void 0 : _7.split(',')[1]) ? [
                    {
                        name: (_8 = element.attachment) === null || _8 === void 0 ? void 0 : _8.split(',')[0],
                        url: (_9 = element.attachment) === null || _9 === void 0 ? void 0 : _9.split(',')[1]
                    }
                ]
                    : []
            };
        });
        this.nikDetail = Object.assign({}, payload);
        this.masterAssessorFormInput = {
            regNumber: payload.regNumber,
            schemes: formattedSchemes.length
                ? formattedSchemes
                : this.masterAssessorFormInput.schemes,
            userId: payload.id
        };
    }
    [_o = Mutations.SET_NIK_DETAIL]() {
        const detail = this.nikDetailOptions.filter((item) => {
            return item.value == this.masterAssessorFormInput.userId;
        });
        this.nikDetail = Object.assign({}, ...detail);
    }
    [_p = Mutations.SET_FILTER](data) {
        this.filters = Object.assign(Object.assign({}, this.filters), data);
    }
    [_q = Mutations.CLEAR_FILTER]() {
        // eslint-disable-next-line arrow-body-style
        Object.keys(this.filters).forEach((key) => (this.filters[key] = null));
    }
    [_r = Mutations.ADD_ATTACHMENT]({ index, name, url }) {
        this.masterAssessorFormInput.schemes[index].attachment = `${name},${url}`;
    }
    [_s = Mutations.SET_ORDER](data) {
        this.orderBy = data;
    }
    // SECTION
    // *ACTIONS* //
    // *GET LIST
    [_t = Actions.GET_MASTER_ASSESSOR_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.url}/${employeeID}?`;
        const params = Object.assign({ ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }, (this.orderBy && {
            orderBy: this.orderBy
        }));
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_LOADING, true);
            this.context.commit(Mutations.SET_PAGINATION_LOADING, true);
            ApiService.get(`${url}${new URLSearchParams(Object.assign(Object.assign({}, params), this.getNonNullFilter)).toString()}`)
                .then((data) => {
                const resData = data.data.result.content.data;
                this.context.commit(Mutations.SET_MASTER_ASSESSOR_LIST, resData);
                this.context.commit(Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: data.data.result.content.totalRecords
                });
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
                this.context.commit(Mutations.SET_PAGINATION_LOADING, false);
            });
        });
    }
    // *DELETE ITEM LIST
    [_u = Actions.DELETE_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const id = payload.id;
        const url = `${API_URLS.url}/${employeeID}/${id}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(url + `?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject(res.data);
                }
                else {
                    resolve();
                }
            })
                .catch((error) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed to delete Assessor.' });
                reject(error);
            });
        });
    }
    // *POST ITEM LIST
    [_v = Actions.POST_DATA]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.url}/${employeeID}?ver=v1`;
        const data = {
            regNumber: this.masterAssessorFormInput.regNumber.toUpperCase(),
            schemes: this.masterAssessorFormInput.schemes,
            userId: this.masterAssessorFormInput.userId
        };
        return new Promise((resolve, reject) => {
            ApiService.post(url, data)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed to create assessor.'
                });
                reject(_response);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
            });
        });
    }
    // *UPDATE ITEM LIST
    [_w = Actions.UPDATE_DATA]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.url}/${employeeID}/${this.nikDetail.id}?ver=v1`;
        const data = {
            regNumber: this.masterAssessorFormInput.regNumber.toUpperCase(),
            schemes: this.masterAssessorFormInput.schemes,
            userId: this.masterAssessorFormInput.userId
        };
        return new Promise((resolve, reject) => {
            ApiService.put(url, data)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed to update assessor.'
                });
                reject(_response);
            });
        });
    }
    // *GET NIK DETAIL OPTIONS
    [_x = Actions.GET_NIK_DETAIL_OPTIONS](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.getUserInfo}/${employeeID}?`;
        const params = {
            ver: 'v1',
            Search: payload.query
        };
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_NIK_SEARCH_LOADING, true);
            ApiService.get(url + new URLSearchParams(params).toString())
                .then((response) => {
                const data = response.data.result.content;
                this.context.commit(Mutations.SET_NIK_OPTIONS, data);
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_NIK_SEARCH_LOADING, false);
            });
        });
    }
    // *GET SCHEMA OPTIONS
    [_y = Actions.GET_SCHEMA_OPTIONS]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.getSchemes}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(url + `/${employeeID}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                if (response.data.result.isError) {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: response.data.statusCode + response.data.result.message
                    });
                }
                else {
                    const data = response.data.result.content.data;
                    this.context.commit(Mutations.SET_SCHEMA_OPTIONS, data);
                }
                resolve(response.data.statusCode);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    // *GET SITE OPTIONS
    [_z = Actions.GET_SITE_OPTIONS]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.getSites}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(url + `/${employeeID}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                if (response.data.result.isError) {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: response.data.statusCode + response.data.result.message
                    });
                }
                else {
                    const data = response.data.result.content;
                    this.context.commit(Mutations.SET_SITE_OPTIONS, data);
                }
                resolve(response.data.statusCode);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    // *UPLOAD ASSESSOR SCHEMA/COMPETENCY CERTIFICATE
    [_0 = Actions.UPLOAD_FILE](payload) {
        const url = `${API_URLS.postFile}`;
        const params = {
            ver: 'v1',
            isImage: payload.isImage
        };
        return new Promise((resolve, reject) => {
            ApiService.postImages(url + `${new URLSearchParams(params).toString()}`, payload.data)
                .then((response) => {
                if (response.data.result.isError) {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: response.data.result.message
                    });
                    reject(response.data.result.message);
                }
                else if (response.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(response.data.result);
                }
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    // *EXPORT ASSESSOR LIST DATA (CREATE/CHANGE)
    [_1 = Actions.EXPORT_ASSESSOR](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        this.context.commit(Mutations.SET_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/${payload}?${new URLSearchParams(Object.assign(Object.assign({}, params), this.getNonNullFilter)).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                this.context.commit(Mutations.SET_LOADING, false);
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            });
        });
    }
    // *DOWNLOAD ASSESSOR LIST DATA
    [_2 = Actions.DOWNLOAD_ASSESSOR](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.url}/${employeeID}/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
            });
        });
    }
    // *UPLOAD CHANGED ASSESSOR DATA FILE
    [_3 = Actions.UPLOAD_CHANGE_ASSESSOR](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/changeupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload change assessor.'
                });
                reject(_response);
            });
        });
    }
    // *SUBMIT CHANGED ASSESSOR DATA
    [_4 = Actions.UPLOAD_SUBMIT_CHANGE_ASSESSOR](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/changeupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload change assessor.'
                });
                reject(_response);
            });
        });
    }
    // *UPLOAD CREATED ASSESSOR DATA FILE
    [_5 = Actions.UPLOAD_CREATE_ASSESSOR](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/createupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload create assessor.'
                });
                reject(_response);
            });
        });
    }
    // *SUBMIT CREATED ASSESSOR DATA
    [_6 = Actions.UPLOAD_SUBMIT_CREATE_ASSESSOR](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/createupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload create assessor.'
                });
                reject(_response);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _s, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _t, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _u, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _v, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _w, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _x, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _y, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _z, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _0, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _1, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _2, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _3, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _4, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _5, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterAssessorModule.prototype, _6, null);
MasterAssessorModule = __decorate([
    Module
], MasterAssessorModule);
export default MasterAssessorModule;
